<template>
  <v-dialog
      v-model="dialog"
      :width="dialogWidth"
      @keydown.enter.prevent="save"
  >
    <v-card
        class="resizable-card"
        :class="{ 'no-select': resizing }"
        :style="{ height: dialogHeight + 'px' }"
    >
      <v-card-title>
        <span class="headline">Artefact</span>
      </v-card-title>
      <v-card-text class="resizable-card__body">
        <v-text-field
            label="Artefact"
            v-model="model.artefact"
            outlined
        ></v-text-field>

        <v-row dense>
          <v-col cols="12" sm="6">
            <v-text-field
                label="X1"
                type="number"
                v-model.number="model.rect[0][0]"
                outlined
            ></v-text-field>
          </v-col>
          <v-col cols="12" sm="6">
            <v-text-field
                label="Y1"
                type="number"
                v-model.number="model.rect[0][1]"
                outlined
            ></v-text-field>
          </v-col>
        </v-row>
        <v-row dense>
          <v-col cols="12" sm="6">
            <v-text-field
                label="X2"
                type="number"
                v-model.number="model.rect[1][0]"
                outlined
            ></v-text-field>
          </v-col>
          <v-col cols="12" sm="6">
            <v-text-field
                label="Y2"
                type="number"
                v-model.number="model.rect[1][1]"
                outlined
            ></v-text-field>
          </v-col>
        </v-row>

        <v-select
            :items="rotateOptions"
            v-model.number="model.rotate"
            label="Rotate"
            outlined
        ></v-select>
      </v-card-text>
      <v-card-actions class="resizable-card__actions">
        <v-spacer/>
        <v-btn @click="cancel" color="blue darken-1" text>
          Cancel
        </v-btn>
        <v-btn @click="save" color="blue darken-1" text>
          Save
        </v-btn>
      </v-card-actions>
      <div class="resize-handle" @mousedown="startResize"></div>
    </v-card>
  </v-dialog>
</template>

<script>
import {ViewRules} from "@/common/ViewRules";
import {LevelTrackLevelPattern} from "@/modules/redactor/models/level-track/LevelTrackLevelPattern";

export default {
  name: "r-level-track-level-pattern-dialog",
  data: () => ({
    dialog: false,
    resolve: null,
    reject: null,
    model: new LevelTrackLevelPattern(),
    rules: ViewRules.READONLY,
    rotateOptions: [
      { text: "0°", value: 0 },
      { text: "90°", value: 90 },
      { text: "180°", value: 180 },
      { text: "270°", value: 270 },
    ],

    dialogWidth: 345,
    dialogHeight: 338,
    resizing: false,
    resizeStartX: 0,
    resizeStartY: 0,
    resizeStartWidth: 345,
    resizeStartHeight: 338,
    viewportPadding: 32,
  }),
  methods: {
    show(rules, model) {
      this.dialog = true;
      this.rules = rules;
      this.model = model || new LevelTrackLevelPattern();
      return new Promise((resolve, reject) => {
        this.resolve = resolve;
        this.reject = reject;
      });
    },
    save() {
      if (this.model.valid()) {
        this.resolve(this.model);
        this.discard();
      } else {
        this.$alert("Invalid config!");
      }
    },
    cancel() {
      this.reject();
      this.discard();
    },
    discard() {
      this.dialog = false;
      this.stopResize();
    },
    startResize(e) {
      this.resizing = true;
      this.resizeStartX = e.clientX;
      this.resizeStartY = e.clientY;
      this.resizeStartWidth = this.dialogWidth;
      this.resizeStartHeight = this.dialogHeight;
      window.addEventListener("mousemove", this.onResize);
      window.addEventListener("mouseup", this.stopResize);
    },
    onResize(e) {
      if (!this.resizing) return;
      const dx = e.clientX - this.resizeStartX;
      const dy = e.clientY - this.resizeStartY;
      let newWidth = this.resizeStartWidth + dx;
      let newHeight = this.resizeStartHeight + dy;

      const minWidth = 260;
      const minHeight = 220;

      if (newWidth < minWidth) newWidth = minWidth;
      if (newHeight < minHeight) newHeight = minHeight;

      this.dialogWidth = newWidth;
      this.dialogHeight = newHeight;
    },
    stopResize() {
      if (!this.resizing) return;
      this.resizing = false;
      window.removeEventListener("mousemove", this.onResize);
      window.removeEventListener("mouseup", this.stopResize);
    }
  },
  beforeDestroy() {
    window.removeEventListener("mousemove", this.onResize);
    window.removeEventListener("mouseup", this.stopResize);
  }
}
</script>

<style scoped>
.resizable-card {
  position: relative;
  display: flex;
  flex-direction: column;
}
.resizable-card__body {
  flex: 1;
  overflow: auto;
}
.resizable-card__actions {
  flex-shrink: 0;
}
.resize-handle {
  position: absolute;
  right: 0;
  bottom: 0;
  width: 14px;
  height: 14px;
  cursor: se-resize;
  border-right: 2px solid rgba(0, 0, 0, 0.3);
  border-bottom: 2px solid rgba(0, 0, 0, 0.3);
}
.no-select {
  user-select: none;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
}
</style>